module.exports = __webpack_public_path__ + "static/media/0.bg with olive branch.e8c4bdde.png";